import { createRouter, createWebHistory } from '@ionic/vue-router';
import JobTerms from '../views/JobTerms.vue';
import Jobs from '../views/Jobs.vue';
import Clients from '../views/Clients.vue';
import auth from '../middlewares/auth';
import logged from '../middlewares/login';
import fingerLogic from '../middlewares/fingerLogic';

const routes = [
  {
    path: '/',
    component: () => import('@/views/Login.vue'),
    meta: {
      middleware: logged,
    }
  },
  {
    path: '/fingerprint/',
    component: () => import('@/views/FingerPrint.vue'),
    meta: {
      middleware: fingerLogic,
    }
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/Home.vue'),
    meta: {
      middleware: auth,
    },
  },
  {
    path: '/job-terms',
    name: 'job-terms',
    component: JobTerms,
    meta: {
      middleware: auth,
    },
  },
  {
    path: '/jobs',
    name: 'jobs',
    component: Jobs,
    meta: {
      middleware: auth,
    },
  },
  {
    path: '/clients',
    name: 'clients',
    component: Clients,
    meta: {
      middleware: auth,
    },
  },
  {
    path: '/payments',
    name: 'payments',
    component: () => import('@/views/Payments.vue'),
    meta: {
      middleware: auth,
    },
  },
  {
    path: '/trackers',
    name: 'trackers',
    component: () => import('@/views/Trackers.vue'),
    meta: {
      middleware: auth,
    },
  },
  {
    path: '/client/:id',
    component: () => import('@/views/ClientEdit.vue'),
    meta: {
      middleware: auth,
    }
  },
  {
    path: '/jobs-archive/:id',
    component: () => import('@/views/JobsArchive.vue'),
    meta: {
      middleware: auth,
    }
  }
]


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  // If no subsequent Middleware exists,
  // the default `next()` callback is returned.
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    // Run the default Vue Router `next()` callback first.
    context.next(...parameters);
    // Then run the subsequent Middleware with a new
    // `nextMiddleware()` callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];

    const context = {
      from,
      next,
      router,
      to,
    };
    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({ ...context, next: nextMiddleware });
  }

  return next();
});

export default router
